export default __webpack_public_path__ + "static/media/btn_big_purchasemvx.cadc61f1.svg";